<template>
  <a-modal :title="ModalTitle" v-model="visible" :confirmLoading="confirmLoading"
    cancelText="取消" okText="保存" width="700px"
    @ok="handleOk" @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item v-for="(item, index) of formData" :key="index" 
        :label="item.label" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-input v-if="item.type === 'input'" v-decorator="[item.name, { rules: item.rules }]"/>
        <a-date-picker v-if="item.type === 'date'" style="width: 100%"  v-decorator="[item.name, { rules: item.rules }]" format="YYYY-MM-DD"/>


        <a-radio-group v-else-if="item.type === 'radio'" placeholder="请选择" v-decorator="[item.name, { rules: item.rules }]">
          <a-radio v-for="(d, index) of seleteItems[item.items.data]" :key="index" :value="d[item.items.value]">{{ d[item.items.label] }}</a-radio>
        </a-radio-group >

        <a-textarea v-else-if="item.type === 'textarea'" :rows="4" v-decorator="[item.name, { rules: item.rules }]"/>
        </a-form-item>
        
    </a-form>
  </a-modal>
</template>

<script>
const formData = [
  {
    name: 'product_name',
    label: '物品名称',
    type: 'input',
    rules: [{ required: true, message: '请输入物品名称!' }]
  },
  {
    name: 'product_type',
    label: '物品类型',
    type: 'radio',
    rules: [{ required: true, message: '请选择物品类型!' }],
    items: {
      data: 'classCategorys',
      label: 'label',
      value: 'value'
    }
  },
  {
    name: 'product_units',
    label: '物品单位',
    type: 'input',
    rules: [{ required: true, message: '请输入物品单位!' }]
  },
  {
    name: 'product_income_price',
    label: '物品进价',
    type: 'input',
    rules: [{ required: true, message: '请输入物品进价!' }]
  },
  {
    name: 'product_sale_price',
    label: '物品售价',
    type: 'input',
    rules: [{ required: true, message: '请输入物品售价!' }]
  },
  {
    name: 'product_alarm',
    label: '库存预警数',
    type: 'input',
    rules: [{ required: true, message: '请输入库存预警数!' }]
  },
]
import C_ITEMS from '@/utils/items'
export default {
  name: 'EditModal',
  inject: ['parent'],
  props: {
    item: Object
  },

  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 15 },
      ModalTitle: '新增物品',
      visible: false,
      confirmLoading: false,
      formData,
      form: this.$form.createForm(this),
      seleteItems: {
        classCategorys: C_ITEMS.productType,
      }
    }
  },

  async created() {
    this.visible = true
    await this.$nextTick()
    if (this.item) {
      this.ModalTitle = '编辑物品'
      let item = await this.getDetail(this.item.product_id)
      let formFields = {}
      for (let d of formData) {
        formFields[d.name] = item[d.name]
      }
      this.form.setFieldsValue(formFields)
    }
  },

  beforeDestroy() {
    this.visible = false
  },

  methods: {
    async getDetail(product_id) {
      let res = await this.$store.dispatch('stockProductDetailAction', {data: {product_id}})
      return res.data
    },
    async handleOk() {
      this.confirmLoading=true;
      try {
        const { item, form } = this
        let params = await form.validateFields()
        if (params) {
          if (item) {
            params.product_id = item.product_id
          }
          let res = await this.$store.dispatch(item ? 'stockProductUpdateAction' : 'stockProductAddAction', { data: params })
          if(res) {
            form.resetFields()
            this.parent.hideEditModal(1)
          }
        }
      } catch {
      }
			this.confirmLoading=false;
    },
    handleCancel() {
      this.parent.hideEditModal(0)
    }
  }
}
</script>
